module.exports = __webpack_public_path__ + "static/media/towerLogo.2a11c141.png";